//imports
import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { currencyFormatLKR } from "../../../src/utils/common/CurrencyFormat";
import Navbar from "../../components/common/Navbar";
import DeleteIcon from "@mui/icons-material/Delete";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { stockdata } from "../../assets/Griddata";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useState, useEffect } from "react";
import {
  externalgetApi,
  externaldeleteApi,
} from "../../services/external/externalApis";
import { STOCK_API_01 } from "../../api/ApiModel";
import { COMPCODE, LOCCODE, RESTCODE, STS } from "../../api/ApiModel";
import StockDetailsPopup from "./StockDetailsPopup"; // Import the StockDetailsPopup component
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchAppBar from "../../components/common/search";
function StockItemDet() {
  //hooks
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null); // State to track the selected item
  const [popupOpen, setPopupOpen] = useState(false); // State to manage the popup open/close
  const SYS_USER = useSelector((state) => state.user) || {};
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [selectedOrderStatusCode, setSelectedOrderStatusCode] = useState(null);
  const [open, setOpen] = useState(false);
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData(); // Initial fetch of the data
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true); // Show loading spinner during fetch
      const result = await externalgetApi(STOCK_API_01, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
      setIsLoading(false);
      console.log("display result ", result);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      FULLNAME: item.FULLNAME,
      GRNNO: item.GRNNO,
      GROSSAMT: currencyFormatLKR(item.GROSSAMT, "LKR", false),
      NETTAMT: currencyFormatLKR(item.NETTAMT, "LKR", false),
      DISCOUNT: currencyFormatLKR(item.DISCOUNT, "LKR", false),
      TAXAMT: currencyFormatLKR(item.TAXAMT, "LKR", false),
      INVOICENO: item.INVOICENO,
      INVOICEDATE: item.INVOICEDATE,
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        const fullName = item.FULLNAME?.toLowerCase() || "";
        const invoiceNo = item.INVOICENO?.toString().toLowerCase() || "";
        return (
          fullName.includes(searchText.toLowerCase()) ||
          invoiceNo.includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };
  //handlers
  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      navigate(`/stock`, { state: { GRNNO: id } });
    } else if (actionText === "Details") {
      const selectedItem = data.find((item) => item.GRNNO === id);
      setSelectedItem(selectedItem);
      setPopupOpen(true);
    } else if (actionText === "Delete") {
      const selectedItem = data.find((item) => item.GRNNO === id); // Set selectedItem state when Delete is clickedconst selectedItem = data.find(item => item.GRNNO === id);
      setSelectedItem(selectedItem);
      handleClickOpen(id);
    }
  };
  // delete api
  const handleDelete = async () => {
    if (selectedOrderStatusCode && selectedItem) {
      try {
        // Make the delete API call, passing GRNNO and other required fields
        await externaldeleteApi(STOCK_API_01, "DELETE", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          GRNNO: selectedItem.GRNNO, // Ensure the correct GRNNO is passed
          STS: CON_STATUS_ACTIVE,
        });

        // Filter out the deleted item from the state
        setFilteredRows((prev) =>
          prev.filter((item) => item.GRNNO !== selectedItem.GRNNO)
        );

        // Show success snackbar
        setSnackbarMessage(`${selectedItem.FULLNAME} deleted successfully!`);
        setOpenSnackbar(true);
        await fetchData();
      } catch (error) {
        // Handle any error during the delete process
        console.error("Failed to delete item:", error);
        setSnackbarMessage("Failed to delete the selected item.");
        setOpenErrorSnackbar(true);
      } finally {
        handleClose(); // Close the delete dialog after operation
      }
    }
  };

  const handleClickOpen = (GRNNO) => {
    setSelectedOrderStatusCode(GRNNO); // Set the selected GRNNO
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrderStatusCode(null);
  };
  const gotToAddItems = () => {
    navigate("/Stock"); // Adjust this path to where you want to navigate
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedItem(null);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
    setOpenErrorSnackbar(false);
  };

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  const menuItems = [
    {
      text: "View",
      icon: <VisibilityIcon />,
      onClick: (GRNNO) => handleItemClick(GRNNO, "Details"),
    },
    {
      text: "Remove",
      icon: <DeleteIcon />,
      onClick: (GRNNO) => handleItemClick(GRNNO, "Delete"), // Corrected from "Remove"
    },
  ];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Setting</Link>
                <Link underline="none"> View GRN </Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={gotToAddItems}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={stockdata.columns}
          rows={rows.map((item) => ({ ...item, id: item.GRNNO }))}
          menuItems={menuItems}
          tabletitle={stockdata.name}
          gridid="GRNNO"
        />
      )}

      {selectedItem && (
        <StockDetailsPopup
          open={popupOpen}
          onClose={handleClosePopup}
          item={selectedItem}
        />
      )}

      <Dialog id="MUS_dial" open={open} onClose={handleClose}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this Stock?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            id="MUS_btn_can"
            onClick={handleClose}
            color="primary"
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
              "&:hover": {
                background: theme.palette.primary.main,
              },
            }}
          >
            No
          </Button>
          <Button
            id="MUS_btn_del"
            onClick={handleDelete}
            sx={{
              backgroundColor: theme.palette.system.danger,
              color: theme.palette.background.paper,
              textTransform: "capitalize",
              borderRadius: 2,
              width: "100px",
              px: 3,
              "&:hover": {
                backgroundColor: theme.palette.system.danger,
              },
            }}
            color="secondary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        id="MUS_sb1"
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          id="MUS_al1"
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        id="MUS_sb2"
        open={openErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          id="MUS_al2"
          onClose={handleSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default StockItemDet;
